var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"id":"delete-milestone-modal","title":_vm.title,"text":_vm.text,"kind":"danger","primary-button-label":_vm.s__('Milestones|Delete milestone')},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('p',{domProps:{"innerHTML":_vm._s(props.text)}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48a8f136","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/milestones/shared/components/delete_milestone_modal.vue
// module id = null
// module chunks = 